import styled from "styled-components";
import { MenuNavButton } from "../../../../../ui/MenuNavButton";
import { menuIndicatorPosition } from "./Indicator";

export const StyledMenuNavButton = styled(MenuNavButton)`
  display: inherit;
  flex: 1 0 ${props => 100 / props.numOfTabs}%;
  align-items: center;
  justify-content: center;
  position: relative;
  transition: color 100ms ease;

  svg {
    width: 40%;
    height: 40%;
  }

  ${menuIndicatorPosition};
`;
